import { render, staticRenderFns } from "./new-stock-trace.vue?vue&type=template&id=7adca85c"
import script from "./new-stock-trace.vue?vue&type=script&lang=js"
export * from "./new-stock-trace.vue?vue&type=script&lang=js"
import style0 from "./new-stock-trace.vue?vue&type=style&index=0&id=7adca85c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports